import { map } from "ramda";
import { HQ_WORKFORCE_SERVICE } from "constants/app";
import {
  getRequest,
  checkStatus,
  parseStatusAndBody,
  postRequest,
  putRequest,
  deleteRequest,
} from "helpers/requests";

import {
  parseTemplateSchema,
  encodeTemplateToJSON,
} from "helpers/transforms/templates";
import { IShiftSet } from "interfaces/schedule";
import { ITemplate } from "types/templates";

// mock/templates.json data is available in JSON-server if needed:
// const MOCK_TEMPLATES = `${MOCK_JSON_SERVER}/templates`;

interface ITemplateResponse {
  uuid: string;
  name: string;
  schedules: ITemplateScheduleResponse[];
}

type ITemplatesListResponse = ITemplateResponse[];

interface ITemplateScheduleResponse {
  updatedAt: string;
  dayOfWeek: string;
  people: IShiftSet[];
}

function getSavedTemplates(location: string): Promise<ITemplate[]> {
  const templatePath = `${HQ_WORKFORCE_SERVICE}/${location}/schedules/templates`;
  return fetch(templatePath, getRequest())
    .then((response) => parseStatusAndBody<ITemplatesListResponse>(response))
    .then((parsedResponse: [number, ITemplatesListResponse]) =>
      checkStatus<ITemplatesListResponse>(parsedResponse)
    )
    .then((resp) => map(parseTemplateSchema, resp));
}

function postTemplate(
  location: string,
  template: ITemplate
): Promise<ITemplate> {
  const postTemplatePath = `${HQ_WORKFORCE_SERVICE}/${location}/schedules/templates`;
  const jsonTemplate = encodeTemplateToJSON(template);
  return fetch(postTemplatePath, postRequest(jsonTemplate))
    .then((response) => parseStatusAndBody<ITemplateResponse>(response))
    .then((parsedResponse: [number, ITemplateResponse]) =>
      checkStatus<ITemplateResponse>(parsedResponse)
    )
    .then((resp) => parseTemplateSchema(resp as ITemplateResponse));
}

function updateTemplate(
  location: string,
  template: ITemplate
): Promise<ITemplate> {
  const postTemplatePath = `${HQ_WORKFORCE_SERVICE}/${location}/schedules/templates/${
    template.uuid
  }`;
  const jsonTemplate = encodeTemplateToJSON(template);
  return fetch(postTemplatePath, putRequest(jsonTemplate))
    .then((response) => parseStatusAndBody<ITemplateResponse>(response))
    .then((parsedResponse: [number, ITemplateResponse]) =>
      checkStatus<ITemplateResponse>(parsedResponse)
    )
    .then((resp) => parseTemplateSchema(resp as ITemplateResponse));
}

function requestDeleteTemplate(location: string, uuid: string): Promise<void> {
  const deleteTemplatePath = `${HQ_WORKFORCE_SERVICE}/${location}/schedules/templates/${uuid}`;
  return fetch(deleteTemplatePath, deleteRequest()).then((response) =>
    checkStatus<void>([response.status, undefined])
  );
}

export {
  getSavedTemplates,
  postTemplate,
  requestDeleteTemplate,
  updateTemplate,
  ITemplateResponse,
  ITemplatesListResponse,
  ITemplateScheduleResponse,
};
